module.exports = __webpack_public_path__ + "img/scan.209d0ba1.png";